import { render, staticRenderFns } from "./video-section.vue?vue&type=template&id=4c4bb8cf&scoped=true"
import script from "./video-section.vue?vue&type=script&lang=js"
export * from "./video-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4bb8cf",
  null
  
)

export default component.exports